import React from "react";
import { Link } from "react-router-dom";
import { HOME_EXPLORE_CARDS } from "../../content/homeMarketing";
import "../MarketingPages.css";

export default function HomeQuickLinks({ t, lang }) {
  return (
    <section
      className={`home-explore container ${lang === "ar" ? "rtl" : ""}`}
      aria-label={lang === "ar" ? "اكتشف احجزلي" : "Discover Ehgezly"}
    >
      <div className="home-explore__grid">
        {HOME_EXPLORE_CARDS.map(({ key, to, image, labelKey, pageKey, ctaKey }) => {
          const page = t.pages?.[pageKey];
          return (
            <Link key={key} to={to} className="explore-card">
              <div className="explore-card__media">
                <img
                  className="explore-card__img"
                  src={image}
                  alt=""
                  loading="lazy"
                  decoding="async"
                />
                <div className="explore-card__overlay" aria-hidden="true" />
                <h3 className="explore-card__title">{t[labelKey]}</h3>
              </div>
              <div className="explore-card__body">
                {page?.quickDesc && (
                  <p className="explore-card__desc">{page.quickDesc}</p>
                )}
                <span className="explore-card__btn">{t[ctaKey]}</span>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}
